module.exports = __webpack_public_path__ + "img/format_textdirection_r_to_l.73450568.svg";